<label class="switch" [class.switch-square]="square" [ngClass]="switchClassStyle">

  <!-- ======================
    Switch Input
  ====================== -->
  <input 
    #inputRef
    appFormFieldStatus
    [ignoreStatus]="ignoreStatus"
    (blur)="onInputTouched()"
    (change)="onInputChange($event)" 
    role="switch"
    class="switch-input" 
    [id]="id"
    [name]="name"
    [type]="type"
    [value]="value ?? null"
    [checked]="isChecked"
    [disabled]="disabled"
    [required]="required"
    [attr.aria-label]="ariaLabel"
    [attr.aria-describedby]="described"/>
  
  <!-- ======================
    Switch Toggle Slider
  ====================== -->
  <span class="switch-toggle-slider">

    <!-- ======================
      Switch On
    ====================== -->
    <span class="switch-on">
      @if (getTemplate('switchOn'); as switchOnTpl) {
        <ng-container *ngTemplateOutlet="switchOnTpl.templateRef; context: { $implicit: iconOn }" />
      }
      @else {
        <i [ngClass]="iconOn"></i>
      }
    </span>

    <!-- ======================
      Switch Off
    ====================== -->
    <span class="switch-off">
      @if (getTemplate('switchOff'); as switchOffTpl) {
        <ng-container *ngTemplateOutlet="switchOffTpl.templateRef; context: { $implicit: iconOff }" />
      }
      @else {
        <i [ngClass]="iconOff"></i>
      }
    </span>

  </span>

  <!-- ======================
    Switch Label
  ====================== -->
  <span class="switch-label">
    @if (getTemplate('switchLabel'); as switchLabelTpl) {
      <ng-container *ngTemplateOutlet="switchLabelTpl.templateRef; context: { $implicit: label }" />
    }
    @else {
      {{label}}
    }
  </span>

</label>

<!-- ===========================
  TextHelp Outlet
=========================== -->
<ng-container 
  *ngTemplateOutlet="getTemplate('textHelp')?.templateRef ?? textHelpTpl; context: { $implicit: textHelp }" />

<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #textHelpTpl let-textHelp>
  @if (textHelp) {
    <div class="form-text" [ngClass]="textHelpClassStyle">{{textHelp}}</div>
  }
</ng-template>
